import React, { Component } from "react";
import {
  dateFormat,
  replaceCharacterWith,
  isValidArray,
  getColor,
  getColorCode,
  formatNumber
} from "../../helper";
import { get } from "lodash";
import { ReadMore } from "../reusableComponent";
import { IIG_PATHS, PATHS } from "../../constant";
import { Link } from "react-router-dom";
import { OrganizationTemplate } from "../reusableComponent";
import { Button, Image, Row } from "react-bootstrap";
import IconTime from "../../assets/icon-time.svg";
import { iigBaseUrl } from "../../globalConfig";
import { KeyboardArrowUp, KeyboardArrowDown } from "@material-ui/icons";
import { projectFormLabel } from "../../helper";
import seprater from "../../assets/Seprater.svg";

class ProjectOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      readMoreToggle: false
    };
  }
  handleReadMore = () => {
    const { readMoreToggle } = this.state;
    this.setState({
      readMoreToggle: !readMoreToggle
    });
  };

  handlePrint = () => {
    window.print();
  };

  render() {
    const {
      data,
      displayOnDetailPage = false,
      parentClass = "project-overview-common",
      fontSize = "27px",
      onToggleCommentSection,
      toggleProjectDetails,
      projectDetails,
      issueTile = true,
      projectData
    } = this.props;
    const revisedDate = get(projectData, "data.revisedTargetCompletionDate");
    const orignalDate = get(projectData, "data.anticipatedDateOfCompletion");
    const projectstatus = get(projectData, "data.projectCompletionDTO.status");
    const Commissioneddate = get(projectData, "data.projectCompletionDTO.date");
    const status =
      get(data, "status") &&
      replaceCharacterWith(get(data, "status", "NA"), "_", " ").toLowerCase();
    const projectPPList =
      data && data.projectPPList && data.projectPPList.length
        ? data.projectPPList
        : [];
    function getUniqueOrganizations(data) {
      // Filter out null values before creating the set
      const filteredData = data.filter(item => item.organizationGroup !== null);
      // Create a Set to store unique organization groups
      const uniqueOrgs = new Set(
        filteredData.map(item => item.organizationGroup)
      );
      // Convert the Set back to an array
      return Array.from(uniqueOrgs);
    }
    const uniqueOrganizations = getUniqueOrganizations(projectPPList);
    const iigProjectReferenceId = get(data, "iigProjectReferenceId");
    const path = window.location.pathname;
    const isIssueListPath = window.location.pathname !== PATHS.ISSUE_LIST;
    let projectLocations = [];
    if (isValidArray(get(data, "locations"))) {
      // projectLocations = get(data, "locations").map((location, index) =>
      //   index < get(data, "locations").length - 1
      //     ? location.state + ", "
      //     : location.state + ""
      // );
      if (get(data, "sponsoredByCategory") === "STATE") {
        projectLocations = get(data, "locations")
          .map(location => {
            if (location.districtIdName.length > 0) {
              return location.districtIdName
                .map((district, districtIndex) => {
                  return district.name;
                })
                .join(", ");
            } else {
              return "-";
            }
          })
          .join(", ");
      } else {
        projectLocations = get(data, "locations").map((location, index) =>
          index < get(data, "locations").length - 1
            ? location.state + ", "
            : location.state + ""
        );
      }
    }
    return (
      <React.Fragment>
        <div
          className={`${parentClass} ${
            !displayOnDetailPage ? "" : "project-overview-for-detail"
          }`}
        >
          <div className="project-name-section">
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ width: "90%" }}
            >
              {get(data, "commonId") !== undefined &&
                get(data, "commonId") !== null && (
                  <div className="id-wrapper-box mr-2 mb-1">
                    <p className=" border-right mb-0 common-project-id">
                      COMMON PROJECT ID{" "}
                      <b className="link-color iig-project-link-color mr-2">
                        <a
                        // href={
                        //   iigBaseUrl +
                        //   IIG_PATHS.IIG_PROJECT_DETAIL +
                        //   "?iigProject=" +
                        //   iigProjectReferenceId
                        // }
                        // target="_blank"
                        >
                          #{get(data, "commonId")}
                        </a>
                      </b>
                    </p>
                  </div>
                )}
              {get(data, "upProjectId") !== undefined &&
                get(data, "upProjectId") !== null && (
                  <div className="id-wrapper-box mr-2 mb-1">
                    <p className=" border-right mb-0 common-project-id">
                      CMIS PROJECT ID{" "}
                      <b className="link-color iig-project-link-color mr-2">
                        #{get(data, "upProjectId")}
                      </b>
                    </p>
                  </div>
                )}
              <div className="id-wrapper-box mb-1 project-id">
                PMG Project Id{" "}
                {path === PATHS.PROJECT_DETAILS ? (
                  <b className="link-color">#{get(data, "displayId", "NA")}</b>
                ) : (
                  <b>
                    <Link
                      to={{
                        pathname: PATHS.PROJECT_DETAILS,
                        search: `?projectId=${get(data, "id")}`,
                        state: {
                          projectId: get(data, "id"),
                          isEdit: false
                        }
                      }}
                    >
                      #{get(data, "displayId", "NA")}
                    </Link>
                  </b>
                )}
              </div>
              {/* {projectPPList &&
                projectPPList.map(item => {
                  if (item.organizationGroup) {
                    return (
                      <OrganizationTemplate
                        title={item.organizationGroup}
                        classes="organisation-name"
                      />
                    );
                  }
                })} */}

              {uniqueOrganizations.map((organization, index) => (
                <OrganizationTemplate
                  key={index}
                  title={organization}
                  classes="organisation-name"
                />
              ))}
            </div>
            {displayOnDetailPage ? (
              <div className="btn-wrapper-responsive hidden-desktop">
                {get(data, "addComment") ? (
                  <Button
                    onClick={onToggleCommentSection}
                    className="btn-small note-btn print-btn print-project"
                  >
                    <div className="note-icon" />
                    Note
                  </Button>
                ) : null}
                <Button
                  className="btn-orange-invert btn-small print-btn print-project"
                  onClick={this.handlePrint}
                >
                  <div className="print-icon orange" />
                  Print
                </Button>
              </div>
            ) : null}
            <div className="project-name-wrapper">
              <h2
                className="project-name"
                style={{ "font-size": `${fontSize}` }}
              >
                {path === PATHS.PROJECT_DETAILS ? (
                  <ReadMore
                    content={get(data, "name", "NA")}
                    clamp={0}
                    displayExpandButtons={false}
                    displayOnProjectDetails={path === PATHS.PROJECT_DETAILS}
                    lineHeightTitle={1.3}
                  />
                ) : (
                  <Link
                    to={{
                      pathname: PATHS.PROJECT_DETAILS,
                      search: `?projectId=${get(data, "id")}`,
                      state: {
                        projectId: get(data, "id"),
                        isEdit: false
                      }
                    }}
                  >
                    {" "}
                    <ReadMore
                      content={get(data, "name", "NA")}
                      clamp={0}
                      displayExpandButtons={false}
                      displayOnProjectDetails={path === PATHS.PROJECT_DETAILS}
                      lineHeightTitle={1.3}
                    />{" "}
                  </Link>
                )}
              </h2>
              <div className="issue-list-status">
                <Button
                  className={`btn-extra-small ${getColor(status)} unClickable`}
                >
                  {status}
                </Button>
              </div>
            </div>
            {get(data, "projectStatusWithRespectToIssueStatus") ||
            get(data, "projectCompletionDTO.status") ? (
              <div className="project-status">
                {get(data, "projectStatusWithRespectToIssueStatus") &&
                get(data, "projectStatusWithRespectToIssueStatus") !==
                  "NO ISSUES" ? (
                  <span
                  /** className={getColorCode(
        get(data, "projectStatusWithRespectToIssueStatus")
      )} */
                  >
                    {get(data, "projectStatusWithRespectToIssueStatus")}
                  </span>
                ) : null}

                {get(data, "projectCompletionDTO.status") ? (
                  <span
                  /** className={getColorCode(
        get(data, "projectCompletionDTO.status")
      )} */
                  >
                    {get(data, "projectCompletionDTO.status") ===
                    "NO IMPLEMENTATION"
                      ? "UNDER DEVELOPMENT"
                      : get(data, "projectCompletionDTO.status")}
                  </span>
                ) : null}
              </div>
            ) : null}
          </div>
          <ul className="sponsor">
            <li>
              <span className="sponsor-label">Sponsored by </span>
              <span className="sponsor-desc">
                {get(data, "sponsoredBy", "NA")}
              </span>
            </li>
            {get(data, "sponsoringDepartment") ? (
              <li
                style={{
                  display:
                    get(data, "sponsoredByCategory") == "STATE" ? "none" : null
                }}
              >
                <span className="sponsor-label">
                  {projectFormLabel(
                    get(data, "sponsoredByid"),
                    "department",
                    "Sponsoring Department"
                  )}
                </span>
                <span className="sponsor-desc">
                  {get(data, "sponsoringDepartment.name", "NA")}
                </span>
              </li>
            ) : null}
            {get(data, "sponsoringDepartment") ? (
              <li
                style={{
                  display:
                    get(data, "sponsoredBy") == "Arunachal Pradesh" &&
                    get(data, "sponsoredByCategory") == "STATE"
                      ? null
                      : "none"
                }}
              >
                <span className="sponsor-label">
                  {projectFormLabel(
                    get(data, "sponsoredByid"),
                    "department",
                    "Beneficiary Department"
                  )}
                </span>
                <span className="sponsor-desc">
                  {get(data, "sponsoringDepartment.name", "NA")}
                </span>
              </li>
            ) : null}
            {get(data, "sponsoringDepartment") ? (
              <li
                style={{
                  display:
                    get(data, "sponsoredBy") != "Arunachal Pradesh" &&
                    get(data, "sponsoredByCategory") == "STATE"
                      ? null
                      : "none"
                }}
              >
                <span className="sponsor-label">
                  {projectFormLabel(
                    get(data, "sponsoredByid"),
                    "department",
                    "Sponsoring Department"
                  )}
                </span>
                <span className="sponsor-desc">
                  {get(data, "sponsoringDepartment.name", "NA")}
                </span>
              </li>
            ) : null}
            {isValidArray(get(data, "locations")) ? (
              <li>
                <span className="sponsor-label">Project Location(s)</span>
                <span className="sponsor-desc">
                  <span>{projectLocations}</span>
                </span>
              </li>
            ) : null}
            <li>
              <span className="sponsor-label">Implementation Mode </span>
              <span className="sponsor-desc">
                {get(data, "implMode", "NA")}
              </span>
            </li>
            <li>
              <span className="sponsor-label">Issue(s) Open</span>
              <span className="sponsor-desc">
                {get(data, "openIssuesCount", 0)}
              </span>
            </li>
            <li>
              <span className="sponsor-label">Issue(s) Resolved</span>
              <span className="sponsor-desc">
                {get(data, "resolvedIssuesCount", 0)}
              </span>
            </li>
          </ul>
          <Row
            className={`${
              projectstatus !== "COMMISSIONED"
                ? "d-flex"
                : "d-flex physical-progress-section"
            }`}
          >
            {displayOnDetailPage ? (
              <div
                className={`${
                  !get(data, "projectCompletionDTO.percentage")
                    ? "without-date"
                    : "physical-progress-wrapper"
                }`}
              >
                <div
                  className={`${
                    !get(data, "projectCompletionDTO.date") &&
                    get(data, "projectCompletionDTO.percentage")
                      ? "physical-percentage"
                      : "progress-upper"
                  }`}
                >
                  Physical Progress:{" "}
                  {get(data, "projectCompletionDTO.percentage") ? (
                    <span>{get(data, "projectCompletionDTO.percentage")}%</span>
                  ) : (
                    <span>-</span>
                  )}
                </div>
                {get(data, "projectCompletionDTO.physicalProgressAsOf") &&
                get(data, "projectCompletionDTO.percentage") &&
                projectstatus !== "COMMISSIONED" ? (
                  <div className="progress-lower">
                    (as of{" "}
                    {dateFormat(
                      get(data, "projectCompletionDTO.physicalProgressAsOf")
                    )}
                    )
                  </div>
                ) : null}
                {get(data, "projectCompletionDTO.date") &&
                (get(data, "projectCompletionDTO.percentage") &&
                  !get(data, "projectCompletionDTO.physicalProgressAsOf")) &&
                projectstatus !== "COMMISSIONED" ? (
                  <div className="progress-lower">
                    (as of {dateFormat(get(data, "projectCompletionDTO.date"))})
                  </div>
                ) : null}
              </div>
            ) : null}

            {displayOnDetailPage ? (
              <>
                <Image className="seprater" src={seprater} />
                <div className="revised-date-wrapper d-flex">
                  <div className="target-date d-flex">
                    {projectstatus == undefined ? <>NA</> : null}{" "}
                    {projectstatus == "COMMISSIONED" ? (
                      <>Commissioning Date:</>
                    ) : null}{" "}
                    {projectstatus != undefined &&
                    projectstatus != "COMMISSIONED" ? (
                      <>Target Date of Completion:</>
                    ) : null}{" "}
                    {projectstatus == "COMMISSIONED" ? (
                      <>
                        <span>
                          {Commissioneddate == null || "" ? (
                            <>-</>
                          ) : (
                            <>{dateFormat(Commissioneddate)}</>
                          )}
                        </span>
                      </>
                    ) : (
                      <>
                        {revisedDate || orignalDate ? (
                          <span>
                            {`${
                              revisedDate
                                ? dateFormat(revisedDate)
                                : dateFormat(orignalDate)
                            }`}
                          </span>
                        ) : (
                          <span>-</span>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </>
            ) : (
              " "
            )}
          </Row>
          {isIssueListPath && issueTile ? (
            <div
              className="toggle-button d-flex mt-4 mb-3"
              onClick={toggleProjectDetails}
            >
              <u>{projectDetails ? "Hide Details" : "Show more details"}</u>
              <div className="ml-2">
                {projectDetails ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </div>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

export default ProjectOverview;
